import { rect, cRect, cSpine, mRect, mPx, CENTER } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Hull } from '../../types';

export const hull_freighter: Hull = {
  id: 'hull_freighter',
  name: 'Freighter',
  drawBody: (ctx, p) => {
    cRect(ctx, 22, 8, 4, p.primary); cRect(ctx, 26, 16, 12, p.primary);
    cRect(ctx, 26, 16, 1, p.light); rect(ctx, CENTER - 8, 26, 1, 12, p.light); rect(ctx, CENTER + 7, 26, 1, 12, p.shadow); cRect(ctx, 37, 16, 1, p.shadow);
    cRect(ctx, 32, 16, 1, p.shadow); cSpine(ctx, 27, 10, p.shadow);
    mRect(ctx, 2, 33, 4, 3, p.accentDark); mPx(ctx, 3, 33, p.accent);
    cRect(ctx, 38, 14, 1, p.dark); cRect(ctx, 22, 8, 1, p.light);
  },
  mounts: {
    [SLOT.COCKPIT]:    { anchor: { x: 32, y: 28 }, cap: (ctx, p) => cRect(ctx, 30, 8, 1, p.dark) },
    [SLOT.WING_L]:     { anchor: { x: 22, y: 34 }, cap: (ctx, p) => { rect(ctx, 21, 33, 4, 4, p.shadow); rect(ctx, 21, 33, 4, 1, p.dark); rect(ctx, 21, 33, 1, 4, p.dark); } },
    [SLOT.WING_R]:     { anchor: { x: 41, y: 34 }, cap: (ctx, p) => { rect(ctx, 39, 33, 4, 4, p.shadow); rect(ctx, 39, 33, 4, 1, p.dark); rect(ctx, 42, 33, 1, 4, p.dark); } },
    [SLOT.ENGINE_L]:   { anchor: { x: 26, y: 39 }, cap: (ctx, p) => { rect(ctx, 24, 38, 5, 2, p.shadow); rect(ctx, 24, 38, 5, 1, p.dark); } },
    [SLOT.ENGINE_R]:   { anchor: { x: 38, y: 39 }, cap: (ctx, p) => { rect(ctx, 35, 38, 5, 2, p.shadow); rect(ctx, 35, 38, 5, 1, p.dark); } },
    [SLOT.WEAPON_TOP]: { anchor: { x: 32, y: 25 }, base: (ctx, p) => { cRect(ctx, 26, 6, 1, p.metal); cRect(ctx, 25, 4, 1, p.metalDark); } },
    [SLOT.NOSE]:       { anchor: { x: 32, y: 22 } },
  },
};
